<template>
  <div class="flex gap-2 p-3 rounded-lg text-sm" :class="status">
    <component :is="dynamicIcon" />

    <div class="flex w-full">
      <div>
        <p class="font-semibold">
          {{ changeCase(title, ElementE.TITLE) }}
        </p>
        <p v-html="changeCase(text, ElementE.SUBTITLE)" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, type Component } from "vue";
import SuccessIcon from "../icons/SuccessIcon.vue";
import InfoIcon from "../icons/InfoIcon.vue";
import WarningIcon from "../icons/WarningIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

interface PropsI {
  status: "success" | "info" | "warning" | "error";
  title: string;
  text: string;
}

const props = defineProps<PropsI>();

const dynamicIcon = ref<null | Component>(null);

onMounted(() => {
  switch (props.status) {
    case "success":
      dynamicIcon.value = SuccessIcon;
      break;

    case "info":
      dynamicIcon.value = InfoIcon;
      break;

    case "warning":
      dynamicIcon.value = WarningIcon;
      break;

    case "error":
      dynamicIcon.value = ErrorIcon;
      break;
  }
});
</script>
